import useFetch from '@hooks/useFetch';
import { HOST_TYPE } from '@utils/api-helper/host';
import {
  normalizeUpscTickerResponse,
  UPSC_TICKER_CMS_API_PATH
} from '@api/fetchers/upscCurrentAffairs';

export interface UpscTickerItem {
  heading: string;
  link: string;
}

export interface UseUpscCurrentAffairsTickerReturn {
  items: UpscTickerItem[];
  isLoading: boolean;
  isError: boolean;
}

const useUpscCurrentAffairsTicker = (): UseUpscCurrentAffairsTickerReturn => {
  const { data, isValidating, isError } = useFetch(
    UPSC_TICKER_CMS_API_PATH,
    { hostType: HOST_TYPE.CMS, useCamelCase: true },
    {
      revalidateIfStale: false,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      dedupingInterval: 60 * 60 * 1000
    }
  );

  const items = normalizeUpscTickerResponse(data);

  return {
    items,
    isLoading: !items.length && !isError && isValidating,
    isError: Boolean(isError)
  };
};

export default useUpscCurrentAffairsTicker;
